






































import { Component, Prop, Vue } from 'vue-property-decorator';

const currencyFormatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    });

@Component
export default class CurrencyField extends Vue {
  @Prop(String) public label;
  @Prop({ type: String, default: '' }) public readonly info!: string;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop(String) public readonly labelCols!: string;
  @Prop(String) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop(String) public readonly prefix!: string;
  @Prop(String) public readonly suffix!: string;

  @Prop({ type: String, default: 'EUR' }) public readonly currency!: string;
  @Prop({ type: Number, default: 2 }) public readonly precision!: number;
  @Prop({ type: Number, default: undefined }) public readonly minValue!: number;
  @Prop({ type: Number, default: undefined }) public readonly maxValue!: number;

  public dataValue: null | number = this.rec[this.field];
  public textValue: string = this.formatDataValue(this.dataValue, true);
  public hasFocus = false;

  public formatDataValue(v: null | number, includeUnit: boolean) {
    // console.log('CurrencyField.formatDataValue', v, includeUnit);
    if (v != null) {
        if (includeUnit) {
            return currencyFormatter.format(Number(v));
        } else {
          return Vue.filter('number')(v);
        }
    }
    return '';
  }

  public parseTextValue(v: string) {
    return parseFloat(v.replace(/,/g, '.'));
  }

  public textInput(newInput) {
    console.log('CurrencyField.handleInput', newInput);
    if (this.textValue) {
      this.dataValue = this.parseTextValue(this.textValue);
      const text = this.formatDataValue(this.dataValue, false);
      if (this.textValue !== text) {
        this.textValue = text;
      }
    } else {
      this.dataValue = null;
    }
    if (this.dataValue !== this.rec[this.field]) {
      this.rec[this.field] = this.dataValue;
      this.$emit('change', this.dataValue);
    }
  }
  public textChange(e) {
    // console.log('CurrencyField.textChange', this.textValue);
  }
  public textEnter(e) {
    // console.log('CurrencyField.textEnter', e);
    this.$emit('enter', e);
  }
  public textFocus(event) {
    // console.log('CurrencyField.textFocus', event);
    this.textValue = this.formatDataValue(this.dataValue, false);
    this.hasFocus = true;
    this.$emit('focus', event);
  }
  public textBlur(e) {
    // console.log('CurrencyField.textBlur', e);
    this.textValue = this.formatDataValue(this.dataValue, true);
    this.hasFocus = false;
    this.$emit('blur', e);
  }


  public created() {
    this.$watch(
      function() { return this.rec[this.field]; },
      function(newValue, oldValue) {
          // console.log('CurrencyField.$watch rec', oldValue, '->',  newValue, 'hasFocus=', this.hasFocus);
          if (oldValue !== newValue) {
            this.dataValue = newValue;
            if (!this.hasFocus) {
              this.textValue = this.formatDataValue(this.dataValue, true);
            }
          }
        }
    );
  }
}
